import createReactComponent from '../createReactComponent';
var Euro = createReactComponent('Euro', [['path', {
  d: 'M4 10h12',
  key: '1y6xl8'
}], ['path', {
  d: 'M4 14h9',
  key: '1loblj'
}], ['path', {
  d: 'M19 6a7.7 7.7 0 00-5.2-2A7.9 7.9 0 006 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2',
  key: 'g9adtl'
}]]);
export default Euro;